import _ from "lodash";

import { http } from "@/utils/http";
const createSyncTag = function (fn) {
  let syncTag = "";
  return function (form, callback) {
    syncTag = Math.random().toString(36);
    fn(
      form,
      (tag => {
        return tag === syncTag ? callback : function () {};
      })(syncTag)
    );
  };
};

const getResultByJobId = async (asyncJobId, form) => {
  const res = await http.post(
    `booking/hotel/search?mode=async&asyncJobId=${asyncJobId}`,
    { ...form }
  );
  return res;
};

export const getHotels = async form => {
  return await http
    .post("booking/hotel/search", { data: form })
    .catch(() => null);
};

export const getHotelsAsync = async (form, callback, onError) => {
  let hotelRes = await http
    .post("booking/hotel/search?mode=async", { data: form })
    .catch(() => {
      onError && onError();
    });
  if (!hotelRes || hotelRes.err) {
    hotelRes = { hotels: [], paging: { count: 0 } };
    onError && onError();
  }

  if (hotelRes.asyncJobId) {
    hotelRes.hotels.forEach(item => {
      item.asyncJobId = hotelRes.asyncJobId;
    });
    getResultByJobId(hotelRes.asyncJobId, { data: form })
      .then(jobRes => {
        hotelRes = jobRes;
        hotelRes && callback(hotelRes);
      })
      .catch(() => {
        onError && onError();
      });
  }
  callback(hotelRes);
};

const getHotelRates = (data, asyncJobId) => {
  let url = "booking/hotel/rates?mode=asyncPagingMerged";
  if (asyncJobId) {
    url = `${url}&asyncJobId=${asyncJobId}`;
  }
  return http.post(url, {
    data
  });
};

const getJobResult = async (query, asyncJobId, callback) => {
  const res = await getHotelRates(query, asyncJobId);

  callback(res);

  if (res.asyncJobId) {
    getJobResult(query, res.asyncJobId, callback);
  }
};

export const getHotelRatesAsync = createSyncTag(async (form, callback) => {
  const res = await getHotelRates(form);
  callback(res);
  if (res.asyncJobId) {
    getJobResult(form, res.asyncJobId, callback);
  }
});

export const getHotelRule = async form => {
  const res = await http
    .post("booking/hotel/rateRule", {
      data: form
    })
    .catch(() => {});
  return res;
};

// 酒店下单
export const createTpHotelOrder = async form => {
  const res = await http
    .post("booking/hotel/bookTp", {
      data: form
    })
    .catch(() => {});
  return res;
};

// 酒店订单列表
export const getHotelOrders = async form => {
  const res = await http
    .post("booking/order/search", {
      data: form
    })
    .catch(() => {});
  return res;
};

export const getOrderDetail = async ref => {
  const orderRes = await http.post("booking/order/search", {
    data: {
      preferred: {
        version: "v2"
      },
      paging: {
        skip: 0,
        limit: 1
      },
      filter: {
        _ids: [ref]
      }
    }
  });
  return _.get(orderRes, "orders.0");
};

export const getHotelRateCalendar = async (date, hotelId) => {
  const query = {
    preferred: {
      version: "v1"
    },
    dateRange: {
      start: date.start.format("YYYY-MM-DD"),
      end: date.end.format("YYYY-MM-DD")
    },
    hotel: {
      _id: hotelId
    }
  };

  const url = "booking/hotel/rateCalendar";

  const res = await http.post(url, { data: query }).catch(() => {});

  return res;
};
